
import { PreviewOptions } from '@/pages/editor/types'

export enum EDITOR_MODE {
  NEW,
  REVISE_DESIGN_CART_ITEM,
  REVISE_DESIGN_ORDER_ITEM
}

export const EDITOR_GRID_CONFIGS = {
  RULER_WIDTH: 32,
  CANVAS_STROKE_COLOR: 'rgb(255,255,255)',
  CANVAS_STROKE_LINE: 1,
  FONT_FAMILY: '-apple-system,BlinkMacSystemFont,Segoe UI,Helvetica Neue,arial,sans-serif',
  FONT_SIZE: 12
}

export const ZOOM_CONFIG = {
  ADDITIONAL_RATIO : 0.3,
  MAX_RATIO : 1.3,
  MIN_RATIO : 0.4
}

export const PRIORITY = {
  SPEED: 'speed',
  QUALITY: 'quality'
}

export const PREVIEW_OPTIONS: PreviewOptions[] = [
  {
    title: 'Delivery Priority',
    note: 'We prioritize speed within the general range for checking data.',
    recommend: 'Recommended for:',
    recommendList: ['Simple and straightforward designs', 'Creating simple promotional materials'],
    value: PRIORITY.SPEED
  },
  {
    title: 'Quality Priority',
    note: 'For thorough data verification, there may be a longer processing time for complex designs.',
    recommend: 'Recommended for:',
    recommendList: ['Fine or complex designs with intricate details', 'Creating high-quality commemorative items'],
    value: PRIORITY.QUALITY
  }
]

export default {
  CURRENT_PRINT_COLOR_KEY: 'current_print_color',
  ACTIVE_OBJECT_TYPES: {
    text: 'text',
    itext: 'i-text',
    image: 'image',
    activeSelection: 'activeSelection'
  },
  TIMEOUT_ERROR: 'TimeOut',
  PLUS: 'plus',
  ACTIONS: {
    UNDO: 'undo',
    REDO: 'redo'
  },
  ENDPOINT: {
    PRINTABLE_SKUS: '/api/v1/printable_skus/',
    SUBMISSIONS: '/api/v1/submissions/',
    SUBMISSION: '/api/v1/submissions/%uuid',
    MULTIPLE_SUBMISSIONS: '/api/v1/multiple_submissions/',
    CART_ITEMS_SUBMISSIONS: '/api/v1/cart_items/%s/submissions',
    CART_ITEMS_SELECTED_COLOR: '/api/v1/cart_items/%s/selected_colors',
    CART_ITEMS: '/cart_items/',
    CART: '/cart',
    CHECKOUT: '/checkout',
    UPLOAD_USER_IMAGE: '/api/v1/user_upload_images/',
    ORDER_ITEM_SUBMISSION: 'api/v1/order_items/%s/submissions',
    ORDER_ITEM_SELECTED_COLOR: 'api/v1/order_items/%s/selected_colors',
    SUBMISSION_REVISIONS: '/api/v1/submission_revisions/%uuid',
    MULTIPLE_SUBMISSION_REVISIONS: '/api/v1/multiple_submission_revisions',
    SUBMISSION_APPLY_REVISION: '/apply_multiple_revisions'
  },
  COLOR_PATTERNS: {
    fullColor: 'fullColor',
    cmykSingleColor: 'cmykSingleColor',
    specialSingleColor: 'specialSingleColor'
  },
  KEY_CODES: {
    LEFT: 37,
    RIGHT: 39,
    TOP: 38,
    BOTTOM: 40,
    DELETE: 8,
    C: 67,
    V: 86,
    Y: 89,
    Z: 90
  },
  TAG_NAME: {
    TEXTAREA: 'TEXTAREA'
  },
  FONT_FAMILIES: [
    {
      cssName: 'Gothic MB101 Medium JIS2004',
      name: 'Gothic MB101 M',
      fileName: 'gothic-mb101-medium-jis2004',
      category: 'standard'
    },
    {
      cssName: 'Gothic MB101 Bold JIS2004',
      name: 'Gothic MB101 B',
      fileName: 'gothic-mb101-bold-jis2004',
      category: 'standard'
    },
    {
      cssName: 'Shin Go Medium JIS2004',
      name: 'Shin Go M',
      fileName: 'shin-go-medium-jis2004',
      category: 'standard'
    },
    {
      cssName: 'Shin Go Bold JIS2004',
      name: 'Shin Go B',
      fileName: 'shin-go-bold-jis2004',
      category: 'standard'
    },
    {
      cssName: 'Shin Maru Go Medium JIS2004',
      name: 'Shin Maru Go M',
      fileName: 'shin-maru-go-medium-jis2004',
      category: 'standard'
    },
    {
      cssName: 'Shin Maru Go Bold JIS2004',
      name: 'Shin Maru Go B',
      fileName: 'shin-maru-go-bold-jis2004', //RECHECK
      category: 'standard'
    },
    {
      cssName: 'Jun 501',
      name: 'Jun 501', //MISSING
      fileName: 'jun-501',
      category: 'standard'
    },
    {
      cssName: 'A1 Mincho',
      name: 'A1 Mincho',
      fileName: 'a1-mincho',
      category: 'standard'
    },
    {
      cssName: 'Ryumin Bold KL JIS2004',
      name: 'Ryumin B-KL',
      fileName: 'ryumin-bold-kl-jis2004',
      category: 'standard'
    },
    {
      cssName: 'Ryumin Heavy KL JIS2004',
      name: 'Ryumin H-KL',
      fileName: 'ryumin-heavy-kl-jis2004',
      category: 'standard'
    },
    {
      cssName: 'Midashi Min MA31 JIS2004',
      name: 'Midashi Min MA31',
      fileName: 'midashi-min-ma31',
      category: 'standard'
    },
    {
      cssName: 'Folk Bold',
      name: 'Folk B',
      fileName: 'folk-bold',
      category: 'fashionable'
    },
    {
      cssName: 'Maru Folk Bold',
      name: 'Maru Folk B',
      fileName: 'maru-folk-bold',
      category: 'fashionable'
    },
    {
      cssName: 'Kakumin Regular',
      name: 'Kakumin R',
      fileName: 'kakumin-regular',
      category: 'fashionable'
    },
    {
      cssName: 'Kakumin Bold',
      name: 'Kakumin B',
      fileName: 'kakumin-bold',
      category: 'fashionable'
    },
    {
      cssName: 'Kumoyaji',
      name: 'Kumoyaji',
      fileName: 'kumoyaji',
      category: 'cute'
    },
    {
      cssName: 'Haruhi Gakuen',
      name: 'Haruhi Gakuen',
      fileName: 'haruhi-gakuen',
      category: 'cute'
    },
    {
      cssName: 'Moaria Regular',
      name: 'Moaria R',
      fileName: 'moaria-regular',
      category: 'cute'
    },
    {
      cssName: 'Moaria Bold',
      name: 'Moaria B',
      fileName: 'moaria-bold',
      category: 'cute'
    },
    {
      cssName: 'Kaimin Tsuki Bold',
      name: 'Kaimin Tsuki B',
      fileName: 'kaimin-tsuki-bold',
      category: 'cute'
    },
    {
      cssName: 'Cinema Letter',
      name: 'Cinema Letter',
      fileName: 'cinema-letter',
      category: 'cute'
    },
    {
      cssName: 'Shin Go Futoline',
      name: 'Shin Go Thick Line',
      fileName: 'shin-go-futoline',
      category: 'decorative'
    },
    {
      cssName: 'Shin Go Shadow',
      name: 'Shin Go Shadow',
      fileName: 'shin-go-shadow',
      category: 'decorative'
    },
    {
      cssName: 'Shin Go Emboss',
      name: 'Shin Go Emboss',
      fileName: 'shin-go-emboss',
      category: 'decorative'
    },
    {
      cssName: 'Shin Maru Go Futoline',
      name: 'Shin Maru Go Thick Line',
      fileName: 'shin-maru-go-futoline',
      category: 'decorative'
    },
    {
      cssName: 'Shin Maru Go Shadow',
      name: 'Shin Maru Go Shadow',
      fileName: 'shin-maru-go-shadow',
      category: 'decorative'
    },
    {
      cssName: 'Shin Maru Go Emboss',
      name: 'Shin Maru Go Emboss',
      fileName: 'shin-maru-go-emboss',
      category: 'decorative'
    },
    {
      cssName: 'Kakushin Gyousho Medium',
      name: 'Kakushin Gyousho M',
      fileName: 'kakushin-gyousho-medium',
      category: 'brush'
    },
    {
      cssName: 'Kanteiryu',
      name: 'Kanteiryu',
      fileName: 'kanteiryu',
      category: 'brush'
    },
    {
      cssName: 'Sei Kaisho CB1',
      name: 'Sei Kaisho CB1',
      fileName: 'sei-kaisho-cb1',
      category: 'brush'
    },
    {
      cssName: 'Kaisho MCBK1',
      name: 'Kaisho MCBK1',
      fileName: 'kaisho-mcbk1',
      category: 'brush'
    },
    {
      cssName: 'UD Shin Go Medium JIS2004',
      name: 'UD Shin Go M',
      fileName: 'ud-shin-go-medium',
      category: 'ud'
    },
    {
      cssName: 'UD Shin Go Bold JIS2004',
      name: 'UD Shin Go B',
      fileName: 'ud-shin-go-bold',
      category: 'ud'
    },
    {
      cssName: 'UD Shin Maru Go Medium JIS2004',
      name: 'UD Shin Maru Go M',
      fileName: 'ud-shin-maru-go-medium',
      category: 'ud'
    },
    {
      cssName: 'UD Shin Maru Go Bold JIS2004',
      name: 'UD Shin Maru Go B',
      fileName: 'ud-shin-maru-go-bold',
      category: 'ud'
    },
    {
      cssName: 'UD Reimin Medium JIS2004',
      name: 'UD Reimin M',
      fileName: 'ud-reimin-medium',
      category: 'ud'
    },
    {
      cssName: 'UD Reimin Bold JIS2004',
      name: 'UD Reimin B',
      fileName: 'ud-reimin-bold',
      category: 'ud'
    }
  ],
  FONT_CATEGORIES: {
    standard: 'Standard',
    fashionable: 'Stylish',
    cute: 'Cute',
    decorative: 'Decorative',
    brush: 'Brush',
    ud: 'Professional UD Fonts'
  },
  TOOL_PANEL_TITLES: {
    text: 'Text',
    image: 'Image',
    activeSelection: 'Group'
  },
  TEXT_FORM_OPTIONS: {
    fontSize: [12, 13, 14, 18, 24, 30, 36, 42, 48, 60, 72, 96, 120],
    lineHeight: [1, 1.1, 1.2, 1.3, 1.4, 1.5, 1.6, 1.7, 1.8, 1.9, 2],
    charSpacing: [
      {
        name: 'Narrow',
        value: -171
      },
      {
        name: 'Slightly Narrow',
        value: -91
      },
      {
        name: 'Standard',
        value: 0
      },
      {
        name: 'Slightly Wide',
        value: 171
      },
      {
        name: 'Wide',
        value: 343
      }
    ]
  },
  MESSAGE: {
    imageSizeLimit:
      'The maximum allowed image size for upload is 50MB. Please use an image under 50MB.',
    imageDimensionLimit:
      'The uploaded image exceeds 8000 pixels in size. Please use an image with dimensions below 8000 pixels.',
    imageMimeType:
      'The uploaded image is not in PNG format. Please use an image in PNG format.'
  },
  EDITOR_MODE: {
    NEW: 'new',
    REVISE_DESIGN_CART_ITEM: 'reviseDesignCartItem',
    REVISE_DESIGN_ORDER_ITEM: 'reviseDesignOrderItem'
  }
}
